import React from "react";
import Classes from "../Routes.module.css";
import PipelineMenu from "./PipelineMenu";
import DropDown from "./Dropdown/DropDown";

function AppointmentCard({
  columnId,
  appt,
  onStatusChange,
  handleopenReschedulePopup,
  handleOpenUpdateStatusPopup,
  allEmployees,
  onMove,
}) {
  return (
    <div className={Classes.apptCard}>
      <div className={Classes.apptHead}>
        <div className={Classes.serviceBar}>
          <img src="/assets/icons/gas-station.png" alt="" style={{ height: '18px' }} />
          <div className={Classes.serviceName}>{appt.service}</div>
        </div>

        <PipelineMenu
          handleopenReschedulePopup={handleopenReschedulePopup}
          allEmployees={allEmployees}
          columnId={columnId}
          appt={appt}
          onMove={onMove}
        />
      </div>

      <div className={Classes.apptRow}>
        <div className={Classes.apptLabel}>Name</div>
        <div className={Classes.apptValue}>{appt.name}</div>
      </div>
      <div className={Classes.apptRow}>
        <div className={Classes.apptLabel}>Phone Number</div>
        <div className={Classes.apptValue}>{appt.phone}</div>
      </div>
      <div className={Classes.apptRow}>
        <div className={Classes.apptLabel}>Address</div>
        <div className={Classes.apptValue} style={{ whiteSpace: "pre-line" }}>{appt.address}</div>
      </div>
      <div className={Classes.apptRow}>
        <div className={Classes.apptLabel}>Requested Fuel</div>
        <div className={Classes.apptValue}>{appt.requestedFuel}</div>
      </div>
      <div className={Classes.apptRow}>
        <div className={Classes.apptLabel}>Fuel Type</div>
        <div className={Classes.apptValue}>{appt.fuelType}</div>
      </div>

      <div className={Classes.apptRow}>
        <div className={Classes.apptLabel}>Status</div>
        <span onClick={handleOpenUpdateStatusPopup}>
          <DropDown
            selectedValue={appt.status || "Upcoming"}
            options={["Completed", "Upcoming", "Cancelled", "On the way", "Delayed"]}
            isDropDown={true}
          />
        </span>
      </div>
    </div>
  );
}
const EmployeeColumn = {};
EmployeeColumn.AppointmentCard = AppointmentCard;
export default EmployeeColumn;
